module.exports = __webpack_public_path__ + "img/transport.a032e8d0.png";